// @ts-ignore
import { Modal } from 'bootstrap';

function attachAutoOpen(): void {
    const autoOpenSelector = '[data-auto-open]';
    const modalElement: HTMLElement | null = document.querySelector(autoOpenSelector);

    if (!modalElement) {
        return;
    }

    const mode = modalElement.dataset.autoOpen;
    const fade = modalElement.classList.contains('fade');

    if (fade && mode === 'instant') {
        modalElement.classList.remove('fade');
    }

    const modal = new Modal(modalElement, {});

    if (fade && mode === 'instant') {
        modalElement.addEventListener('hidden.bs.modal', (event) => {
            //modalElement.addEventListener('shown.bs.modal', function (event) {
            modalElement.classList.add('fade');
        }, {once : true});
    }

    modal.show();
}

function attachAutoFocus(): void {
    const autoFocusSelector = '[data-auto-focus]';
    const modalElements: NodeListOf<HTMLInputElement> = document.querySelectorAll(autoFocusSelector);

    if (!modalElements) {
        return;
    }

    for (let modalElement of Array.from(modalElements)) {
        const focusTarget = modalElement.dataset.autoFocus;

        if (focusTarget === undefined) {
            return;
        }

        setFocusTarget(focusTarget, modalElement);
    }
}

function setFocusTarget(focusTarget: string, modalElement: HTMLElement): void {
    modalElement.addEventListener('shown.bs.modal', (event) => {
        const focusTargetElement: HTMLElement | null = document.querySelector(focusTarget);

        if (!focusTargetElement) {
            return;
        }

        focusTargetElement.focus();
    });
}

window.addEventListener('DOMContentLoaded', (event) => {
    attachAutoFocus();
    attachAutoOpen();
}, {once : true});


